import { UserRole, UserStatus } from "@/common/api/datasources/Api";

export const USER_ROLE_TRANSLATION_KEY: Record<UserRole, string> = {
    [UserRole.ADMIN]: "users.role.options.admin",
    [UserRole.OWNER]: "users.role.options.owner",
    [UserRole.STAFF]: "users.role.options.staff",
    [UserRole.TENANT]: "users.role.options.tenant",
    [UserRole.UNASSIGNED]: "users.role.options.unassigned",
} as const;

export const USER_STATUS_TRANSLATION_KEY: Record<UserStatus, string> = {
    [UserStatus.ACTIVE]: "users.status.options.active",
    [UserStatus.PENDING]: "users.status.options.pending",
    [UserStatus.INACTIVE]: "users.status.options.inactive",
    [UserStatus.SUSPENDED]: "users.status.options.suspended",
} as const;

// Хелпери для отримання ключа перекладу
export const getUserRoleTranslationKey = (role: UserRole): string => 
    USER_ROLE_TRANSLATION_KEY[role];

export const getUserStatusTranslationKey = (status: UserStatus): string => 
    USER_STATUS_TRANSLATION_KEY[status]; 